import type { CSSProperties } from 'react';

// Pick a readable text color (dark or white) for a given label background.
// Uses perceived luminance so mid-tone palette colors stay legible.
export function labelTextColor(hex: string): string {
  const c = hex.replace('#', '');
  if (c.length !== 6) return '#ffffff';
  const r = parseInt(c.slice(0, 2), 16);
  const g = parseInt(c.slice(2, 4), 16);
  const b = parseInt(c.slice(4, 6), 16);
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance > 0.6 ? '#1f2937' : '#ffffff';
}

// Fixed palette offered when creating a new label.
export const LABEL_COLORS = [
  '#ef4444', '#f97316', '#f59e0b', '#eab308', '#22c55e', '#14b8a6',
  '#06b6d4', '#3b82f6', '#6366f1', '#8b5cf6', '#ec4899', '#6b7280',
];

// Inline style for an outlined label chip: tinted background, label-coloured
// text and border. `--label-color` lets dark mode lighten the text and border
// (see `.label-chip` in index.css); light mode renders the inline values.
export function labelChipStyle(color: string | null | undefined): CSSProperties {
  return {
    '--label-color': color || '#6b7280',
    backgroundColor: color ? `${color}20` : '#e5e7eb',
    color: color || '#374151',
    borderWidth: '1px',
    borderColor: color || '#d1d5db',
  } as CSSProperties;
}
